<template>
    <div class="content mt20">
        <div class="account-content bgfff">
            <div class="one-bd clearfix">
                <a :class="{active:type === 1}" href="javascript:void(0);" @click="getLabel(1);">微信账号</a>
                <a :class="{active:type === 2}" href="javascript:void(0);" @click="getLabel(2);">微博账号</a>
                <a :class="{active:type === 3}" href="javascript:void(0);" @click="getLabel(3);">头条账号</a>
                <a :class="{active:type === 4}" href="javascript:void(0);" @click="getLabel(4);">快手账号</a>
                <a :class="{active:type === 5}" href="javascript:void(0);" @click="getLabel(5);">B站账号</a>
                <a :class="{active:type === 6}" href="javascript:void(0);" @click="getLabel(6);">抖音账号</a>
            </div>
        </div>
        <div class="bgfff mt20">
            <div class="bd clearfix">
                <button class="btn btn-blue fl" @click="addLabel(1);"><i class="icons add-blue-icon"></i>新建标签</button>
                <div class="search-warp fr">
                    <input type="text" name="search" placeholder="请输入媒体号" class="input-text" v-model="keyword"> 
                    <span class="search-btn" href="javascript:void(0);" @click="mediaSearch();">
                        <i class="icons search-icon1"></i>
                    </span>
                </div>
            </div>
            <div class="account-tag clearfix mt15">
                <div class="tagNav fl">
                    <a href="javascript:void(0);" v-for="(item,index) in lableList" :class="{active:labelIndex === index}" :key="index" @click="getLabelMedia(item.id,index,0);">{{item.name}}({{item.num}})</a>
                </div>    
                <div class="tagContain hidden">
                    <dl class="tagLi" v-if="lableList != ''">
                        <dt>{{lableList[labelIndex].name}}<span v-if="lableList[labelIndex].id > 0"><i class="icons icon-edit cp ml10" @click="addLabel(2);"></i><i class="icons icon-del cp ml10" @click="delLabel();"></i></span></dt>
                        <dd class="clearfix">
                            <label class="checkbox-warp fl clearfix" @click="checkAll($event);">
                                <label class="checkbox fl">
                                    <input type="checkbox" class="checkbox-i" :checked="ids.length === initialIds.length && ids.length > 0 ? true : false">
                                    <span class="checkbox-ico"></span>
                                </label>
                                <div class="hidden">全选</div>
                            </label>
                            <a class="ml10 fl cr2a" href="javascript:void(0);" @click="playLabel();"><i class="icons icon-tag"></i>打标签</a>
                        </dd>
                        <dd class="tagLi-dd clearfix" v-for="(item,index) in mediaList" :key="index">
                            <label class="checkbox-warp w230 fl clearfix">
                                <label class="checkbox fl">
                                    <input type="checkbox" class="checkbox-i" v-model="ids" :value="item.id">
                                    <span class="checkbox-ico"></span>
                                </label>
                                <div class="hidden">
                                    <p class="fw7">{{item.nickname}}</p>
                                    <span>{{item.alias}}</span>
                                </div>
                            </label>
                            <div class="tagLi-a hidden">
                                <a href="javascript:void(0);" v-for="(items,index) in item.tags" :key="index">{{items}}</a>
                            </div>
                        </dd>
                        <!-- 暂无数据 -->
                        <div class="no-data" v-if="mediaList <= 0 && !$parent.showLoad"><img src="/static/images/no_data.png" class="img" /><span class="text">没有数据哦...</span></div>
                    </dl>            
                </div>
                <!-- 分页 -->
                <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
        </div>
        <!-- 添加标签 -->
        <Dialog ref="labelModal" :callback="saveLabel" width="400" title="添加标签">
            <div slot="mdBox">
                <input class="input-text" v-model="labelName" maxlength="7" id="planName" type="text" placeholder="请输入标签名称（最多7个字）"/>
            </div>
        </Dialog>
        <!-- 打标签 -->
        <Dialog ref="labelListModal" :callback="saveSelectLabel" width="500" title="添加标签">
            <div slot="mdBox">
                <div class="checkbox-list clearfix">
                    <label class="checkbox-warp fl clearfix" v-for="(item,index) in lableList" v-if="item.id > 0" :key="index">
                        <label class="checkbox fl">
                            <input type="checkbox" class="checkbox-i" :value="item.id" v-model="selectIds">
                            <span class="checkbox-ico"></span>
                        </label>
                        <div class="hidden">{{item.name}}</div>
                    </label>
                </div>
            </div>
        </Dialog>
        <!-- 是否删除提示 -->
        <Dialog ref="delModal" :callback="enterDel" type="confirm" title="提示">
            <div slot="mdBox">
                <p class="ac">是否删除该标签？</p>
            </div>
        </Dialog>
  	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import page from '../../components/page.vue';
export default {
    components:{Dialog,page},
    data() {
        return {
           type:1,//账号列表类型
           lableList:[],//标签列表
           operationType:'',//1是新建 2是保存
           initialMediaList:[],//初始媒体列表
           mediaList:[],//媒体列表
           keyword:'',//媒体搜索关键词
           id:0,//标签ID
           totalCount:'',//总数
           initialIds:[],//页面总的媒体ID
           ids:[],//选择的id
           labelIndex:0,//标签的序列
           labelName:'',//标签名称
           selectIds:[],//打标签所选的id
           page:1,
           limit:20,
        }
    },
    mounted() {
		let that = this;
        this.$nextTick(()=> {
            that.getLabel(1);
        })
    },
    created() {
		
    },
    methods: {
        // 获取标签
        getLabel (type) {
            let that = this;
            that.ids = [];
            that.type = type;
            that.$api.post('label/list',{type:that.type},r =>{
                that.$parent.returnCode(r,function(){
                    that.lableList = r.data;
                    let id = r.data[0].id;
                    that.getLabelMedia(id,0,0);
                })
            })
        }, 
        // 获取标签媒体数据
        getLabelMedia (id,index,pageType) {
            let that = this;
            that.labelIndex = index;
            if(pageType === 0){//重置分页
                that.page = 1;
            }
            that.id = id;
            that.ids = [];
            that.$parent.loadModal(true,'获取数据中...');
            that.$api.post('label/medialist',{type:that.type,id:id,page:that.page,pagesize:that.limit,search:that.keyword},r =>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.mediaList = r.data.list;
                    that.totalCount = r.data.total;
                    let ids = [];
                    for(let i of r.data.list){
                        ids.push(i.id);
                    }
                    that.initialIds = ids;
                })
            })
        }, 
        // 全选
        checkAll (e) {
            let checked = e.target.checked;
            if(checked == true){//全选
                this.ids = this.initialIds;
            }else{//全不选
                this.ids = [];
            }
        },
        // 新建标签
        addLabel (type) {
            let that = this;
            that.labelName = '';
            that.operationType = type;
            that.$refs.labelModal.showMaskFun();
        },
        // 保存标签
        saveLabel () {
            let that = this;
            let operationType = that.operationType;
            let id = 0;
            if(operationType === 2){//修改
                id = that.id;
            }
            that.$parent.loadModal(true,'提交数据中...');
            that.$api.post('label/edit',{type:that.type,id:id,name:that.labelName},r =>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    if(operationType === 2){//修改
                        that.lableList[that.labelIndex].name = that.labelName;
                    }else if(operationType === 1){//新增
                        that.lableList.push(r.data);
                    }
                    that.$refs.labelModal.closeMask();
                })
            })
        },
        // 打标签
        playLabel () {
            let that = this;
            if(that.ids.length <= 0){
                that.$utils.alertText('请选择需要打标签的媒体号');
                return;
            }else if(that.lableList.length <= 2){
                that.$utils.alertText('暂无可打标签，请新建标签');
                return;
            }
            that.$refs.labelListModal.showMaskFun();
        },
        // 保存已选标签
        saveSelectLabel () {
            let that = this;
            if(that.selectIds.length > 3){
                that.$utils.alertText('最多选择3个标签');
                return;
            }
            that.$parent.loadModal(true,'提交数据中...');
            that.$api.post('label/addlabel',{type:that.type,tagid:that.selectIds.join(","),accountid:that.ids.join(",")},r =>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.$refs.labelListModal.closeMask();
                    that.selectIds = [];
                    that.ids = [];
                    that.getLabel(1);
                })
            }) 
        },
        // 媒体搜素
        mediaSearch () {
            let that = this;
            // let keyword = that.keyword;
            // let initialMediaList = that.initialMediaList.list;
            // let list = [];
            // for(let i of initialMediaList){
            //     if(i.nickname.indexOf(keyword) != -1){
            //         list.push(i);
            //     }
            // }
            // that.mediaList = list;
            let index = that.labelIndex;
            let id = that.lableList[index].id;
            that.getLabelMedia(id,index,0);
        },
        // 翻页
        getTableData () {
            let index = this.labelIndex;
            let id = this.lableList[index].id;
            this.getLabelMedia(id,index,1);
        },
        // 删除标签
        delLabel () {
            this.$refs.delModal.showMaskFun(); 
        },
        // 确认删除
        enterDel () {
            let that = this;
            let id = that.lableList[that.labelIndex].id;
            that.$parent.loadModal(true,'提交数据中...');
            that.$api.post('label/del',{id:id},r =>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.getLabel(that.type);
                    that.$utils.alertText('删除成功');
                    that.$refs.delModal.closeMask();
                })
            }) 
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/accountList/accountListTag.vue